export default __webpack_public_path__ + "static/media/Health-Safety-Policy_1.42415ad5.jpg";